import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from "rxjs";
import { retry, tap, take, shareReplay } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class ApiService {
  private apiUrl: string;
  /** Problems stream to live reload by subscribing it from templates or controllers */
  private items$ = new BehaviorSubject<Array<any>>([]);
  constructor(private http: HttpClient) { }
  /**
   * Sets api url to send calls
   * @param url
   */
  public setAPiUrl(url: string) {
    this.apiUrl = url;
  }
  /**
   * Gett all obituaries and store it in subject stream
   * @param options
   */
  public getAll(itemName: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${itemName}`).pipe(retry(2), take(1),
      tap((items) => {
        this.items$.next(items);
      })
    );
  }
  /**
   * Give an item from database by his id
   * @param id
   */
  public getById(itemName: string, itemId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${itemName}/${itemId}`).pipe(retry(2), take(1));
  }
  /**
   * Remove an item
   * @param id
   */
  public remove(itemName: string, id: string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${itemName}/${id}`).pipe(retry(2), take(1));
  }
  /**
   *
   * @param itemName
   * @param item
   */
  public create(itemName: string, item: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${itemName}`, item).pipe(retry(2), take(1));
  }
  /**
   *
   * @param itemName
   * @param itemId
   * @param updatedItem
   */
  public update(itemName: string, itemId: string, updatedItem: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${itemName}/${itemId}`, updatedItem).pipe(retry(2), take(1));
  }
  /** Returns observable problems list */
  public getAsObservable(): Observable<Array<any>> {
    return this.items$.asObservable().pipe(
      shareReplay()
    );
  }
  /** Returns observable problems list */
  public getSnapshot(): Array<any> {
    return this.items$.getValue();
  }
}
